export default __webpack_public_path__ + "static/media/google-play.547ed951.svg";